import { STATUS, STATUS_REASON } from '@/constants/status'

export const deactivateInput = (hasPermission, status, statusChange) =>
  !hasPermission ||
  status === STATUS.MIGRATED ||
  (status === STATUS.INACTIVE && statusChange?.reason === STATUS_REASON.PRE_MIGRATION)
